import React from 'react';
import BarChartWidget from './widgets/BarChartWidget';
import PieChartWidget from './widgets/PieChartWidget';
import MetricCardWidget from './widgets/MetricCardWidget';

export default function WidgetRenderer({ widget }) {
  switch (widget.type) {
    case 'bar_chart':
      return <BarChartWidget widget={widget} />;
    case 'pie_chart':
      return <PieChartWidget widget={widget} />;
    case 'metric_card':
      return <MetricCardWidget widget={widget} />;
    default:
      return (
        <div className="p-4 border border-slate-200 rounded-lg">
          <div className="text-sm text-slate-400">Widget desconhecido: {widget.type}</div>
        </div>
      );
  }
}
